import { HTTP } from "@/utils/http-common"

export default {
  list(params = {}) {
    return new Promise((resolve, reject) => {
      HTTP.get("/business/refill-requests", { params })
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  get(id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/business/refill-requests/${id}`)
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  /**
   * Cree une demande. Utilise FormData pour permettre l upload du bon de commande.
   * payload : { product, quantity, notes, order_document (File),
   *             desired_delivery_date, delivery_shop, destination }
   */
  create(payload) {
    const fd = new FormData()
    if (payload.product != null) fd.append("product", payload.product)
    fd.append("quantity", payload.quantity)
    if (payload.desired_delivery_date) fd.append("desired_delivery_date", payload.desired_delivery_date)
    if (payload.delivery_shop != null) fd.append("delivery_shop", payload.delivery_shop)
    if (payload.destination) fd.append("destination", payload.destination)
    if (payload.notes) fd.append("notes", payload.notes)
    if (payload.order_document) fd.append("order_document", payload.order_document)
    return new Promise((resolve, reject) => {
      HTTP.post("/business/refill-requests", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  cancel(id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/refill-requests/${id}/cancel`)
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  process(id, processing_notes = "") {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/refill-requests/${id}/process`, { processing_notes })
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  reject(id, processing_notes = "") {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/refill-requests/${id}/reject`, { processing_notes })
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  internalValidate(id, processing_notes = "") {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/refill-requests/${id}/internal-validate`, { processing_notes })
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  internalReject(id, processing_notes = "") {
    return new Promise((resolve, reject) => {
      HTTP.post(`/business/refill-requests/${id}/internal-reject`, { processing_notes })
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  getDeliveryShops() {
    return new Promise((resolve, reject) => {
      HTTP.get("/business/refill-requests/delivery-shops")
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  getNotifConfig() {
    return new Promise((resolve, reject) => {
      HTTP.get("/business/refill-requests/notif-config")
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },

  updateNotifConfig(emails) {
    return new Promise((resolve, reject) => {
      HTTP.patch("/business/refill-requests/notif-config", { emails })
        .then(r => resolve(r.data))
        .catch(e => reject(e))
    })
  },
}
